import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const serviceTypeListingApi = async (payload) => {
    const request = requestAuthOption("GET")

    try {
        const response = await fetch(
            `${server}services?paginate=${payload.paginate}&size=${payload.size}&sort_order=${payload.sort_order}&sort=${payload.sort}&search=${payload.search}&filter[status]=${payload.filterStatus}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const serviceTypeDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}services/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const addServiceTypeApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}services`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const updateServiceTypeApi = async (payload) => {
    const request = requestAuthOption("PUT", payload.data)
    try {
        const response = await fetch(
            `${server}services/${payload.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const deleteServiceTypeApi = async (payload) => {
    const request = requestAuthOption("DELETE")
    try {
        const response = await fetch(
            `${server}services/${payload?.ID}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const bulkDeleteServiceTypeApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}services/bulk-delete`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};

export const exportServiceTypeApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}services/export`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed") {
                        Helpers.routeToLogin();
                    } else {
                        resolve(data);
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // Helpers.routeToLogin();
                // throw error;
            })
        })
    }
};
